import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { CommonMaterialModule } from '@nrwl/common-material';
import { UserAuth, CommonLibModule } from '@nrwl/common-lib';

import { NavbarComponent } from './components/navbar/navbar.component';

@NgModule({
    declarations: [NavbarComponent],
    imports: [CommonModule, CommonMaterialModule, RouterModule, CommonLibModule],
    providers: [{ provide: 'userAuth', useExisting: UserAuth }],
    exports: [NavbarComponent]
})
export class NavbarModule {}
